import { render, staticRenderFns } from "./MyPresent.vue?vue&type=template&id=54ad0438&scoped=true&"
import script from "./MyPresent.vue?vue&type=script&lang=js&"
export * from "./MyPresent.vue?vue&type=script&lang=js&"
import style0 from "./MyPresent.vue?vue&type=style&index=0&id=54ad0438&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad0438",
  null
  
)

export default component.exports